import {
  color,
  IconCorner1,
  IconCorner2,
  IconCorner3,
  IconCorner4,
  SpaceBetween,
  spacing,
  styled,
} from '@lessonup/ui-components';
import React from 'react';
import { useEditorTranslation } from '../../../../../hooks/useEditorTranslation';
import { SettingsToggle } from '../../../../SettingsToggle/SettingsToggle';
import { EditorTextField } from '../../EditorInputFields/EditorTextField';
import { CORNER_RADIUS_VALUES } from './borderConstants';

interface BorderRadiusControlsProps {
  currentValue: number;
  onBorderRadiusChange: (value: number) => void;
  id: string;
}

export const BorderRadiusControls: React.FC<BorderRadiusControlsProps> = ({
  currentValue,
  onBorderRadiusChange,
  id,
}) => {
  const { t } = useEditorTranslation();

  return (
    <SpaceBetween direction="y" spacing={spacing.size8}>
      <SpaceBetween direction="x" spacing={spacing.size4} alignItems="center" justifyContent="space-around">
        <SettingsToggle
          type="checkbox"
          toggleVariant="caption"
          caption={t('contextSidebar.settings.size.none')}
          value={CORNER_RADIUS_VALUES.none}
          onChange={() => onBorderRadiusChange(CORNER_RADIUS_VALUES.none)}
          checked={currentValue === CORNER_RADIUS_VALUES.none}
          icon={<IconCorner1 />}
        />
        <SettingsToggle
          type="checkbox"
          toggleVariant="caption"
          caption={t('contextSidebar.settings.size.small')}
          value={CORNER_RADIUS_VALUES.small}
          onChange={() => onBorderRadiusChange(CORNER_RADIUS_VALUES.small)}
          checked={currentValue === CORNER_RADIUS_VALUES.small}
          icon={<IconCorner2 />}
        />
        <SettingsToggle
          type="checkbox"
          toggleVariant="caption"
          caption={t('contextSidebar.settings.size.medium')}
          value={CORNER_RADIUS_VALUES.medium}
          onChange={() => onBorderRadiusChange(CORNER_RADIUS_VALUES.medium)}
          checked={currentValue === CORNER_RADIUS_VALUES.medium}
          icon={<IconCorner3 />}
        />
        <SettingsToggle
          type="checkbox"
          toggleVariant="caption"
          caption={t('contextSidebar.settings.size.large')}
          value={CORNER_RADIUS_VALUES.large}
          onChange={() => onBorderRadiusChange(CORNER_RADIUS_VALUES.large)}
          checked={currentValue === CORNER_RADIUS_VALUES.large}
          icon={<IconCorner4 />}
        />
      </SpaceBetween>
      <EditorTextField
        id={id}
        type="number"
        orientation="horizontal"
        label={t('contextSidebar.settings.custom')}
        onChange={(e: React.FormEvent<HTMLInputElement>) => {
          onBorderRadiusChange(Number(e.currentTarget.value));
        }}
        value={currentValue}
        min={0}
        max={999}
        size="small"
        endSlot={<StyledCustomUnit>{'px'}</StyledCustomUnit>}
      />
    </SpaceBetween>
  );
};

const StyledCustomUnit = styled.span`
  color: ${color.neutral.surface.text};
`;
